import { Card, styled } from "@material-ui/core";
import React from "react";

export const ButtonCard = styled(({ fullWidth, flexGrow, ...rest }) => (
  <Card {...rest} />
))(({ fullWidth, flexGrow }: { fullWidth?: boolean; flexGrow?: number }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  ...(fullWidth && {
    flex: "100%",
  }),
  ...(flexGrow && {
    flexGrow: flexGrow,
  }),
}));
